<template>
  <div>
    <div class="vx-row">
      <div v-if="nenhumProdutoEncontrado === false" class="vx-col w-full mb-2">
        <vs-button
          color="danger"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
          @click="resetarDescontosCupom()"
          >
          {{ $t('Resetar') }}  {{ $t('Cupom') }}
        </vs-button>
        <table class="table-bordered">
          <tr>
            <th></th>
         <th class="w-1/2">{{ $t('Produto') }}</th>
            <th class="w-1/5">{{ $t('Valor') }}</th>
            <th class="">{{ $t('Desconto') }}(%)</th>
            <th class="text-center">{{ $t('Cupom') }} {{ $t('Desconto') }}(%)</th>
            <th class="w-1/5">{{ $t('Valor') }} {{ $t('Final') }}</th>
          </tr>
          <tr
            v-for="(item, index) in listProdutosObrigatorios"
            :key="'Obri' + index"
          >
            <td>
              <vs-checkbox
                v-model="form.produtosSelecionados"
                :vs-value="item"
                :disabled="item.obrigatorio"
                @input="selecionaProduto(item)"
              >
              </vs-checkbox>
            </td>
            <td>{{ item.nomeProduto }}</td>
            <td>
              <div class="flex justify-between items-center">
                <div class="text-center">{{ item.valor | currency }}</div>
                <vs-button
                  v-if="item.alterarValor && AlterarValorProduto"
                  radius
                  v-tooltip="'Alterar o Valor do Produto'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="
                    (novoValorProduto = item),
                      (mostrarModalNovoValorProduto = true)
                  "
                ></vs-button>
              </div>
            </td>
            <td>
              <div class="flex justify-between items-center">
                <div>
                  {{ item.descontoConcedido.toFixed(2) }}
                  %
                </div>
                <vs-button
                  v-if="
                    verificaPermissaoDescontoPorPerfil(
                      item.idsPerfilDesconto,
                    ) &&
                    item.porcentagemDescontoMaxima &&
                    item.podeExibirBotaoDesconto
                  "
                  radius
                  v-tooltip="'Dar Desconto'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-percent"
                  @click="abrirModalDesconto(item)"
                ></vs-button>
              </div>
            </td>
            <td>
              {{ Math.round(item.valorDescontoCupomExibicao || 0).toFixed(2) }}%
            </td>
            <td class="p-4">{{ item.valorFinal | currency }}</td>
          </tr>
          <tr>
            <td colspan="6"><hr class="my-3" /></td>
          </tr>
          <tr
            v-for="(item, index) in listProdutosNaoObrigatorios"
            :key="'NObri' + index"
            v-if="item.exibir == true"
          >
            <td>
              <vs-checkbox
                @input="selecionaProduto(item)"
                v-model="form.produtosSelecionados"
                :vs-value="item"
              >
              </vs-checkbox>
            </td>
            <td>{{ item.nomeProduto }}</td>
            <td>
              <div class="flex justify-between items-center"></div>
              <div>{{ item.valor | currency }}</div>
              <vs-button
                v-if="item.alterarValor && AlterarValorProduto"
                radius
                v-tooltip="'Alterar o Valor do Produto'"
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-percent"
                @click="
                  (novoValorProduto = item),
                    (mostrarModalNovoValorProduto = true)
                "
              ></vs-button>
            </td>
            <td>
              <div class="flex justify-between items-center">
                <div>{{ item.descontoConcedido.toFixed(2) }} %</div>
                <vs-button
                  v-if="
                    verificaPermissaoDescontoPorPerfil(
                      item.idsPerfilDesconto,
                    ) &&
                    item.porcentagemDescontoMaxima &&
                    item.podeExibirBotaoDesconto
                  "
                  radius
                  v-tooltip="'Dar Desconto'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-percent"
                  @click="abrirModalDesconto(item)"
                ></vs-button>
              </div>
            </td>
            <td>{{ item.valorDescontoCupomExibicao || 0 }}%</td>
            <td>
              {{ item.valorFinal | currency }}
            </td>
          </tr>
        </table>
        <hr class="my-2" />
        <div class="vx-col sm:w-2/4 w-full mb-2">
         <label for class="vs-input--label">{{ $t('Selecione') }} {{ $t('comissão') }} {{ $t('única') }}.</label>
          <vs-switch
            color="success"
            v-model="comissaoRemovidaParcelaUnica"
            id="permiteInvoiceSelfService"
            @change="removerComissaoParcelaUnica"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
        <div
          class="flex items-start flex-col justify-start w-full py-4"
          v-if="configurarComissao && !comissaoRemovidaDesconto"
        >
          <h5 class="mb-5 flex-shrink-0">{{ $t('Comissão') }} {{ $t('Recorrente') }}</h5>

          <div class="flex items-center justify-center w-full gap-2">
            <input
              type="range"
              class="slider h-2 rounded-lg appearance-none cursor-pointer w-full"
              :min="regional.valorMinimoComissao"
              :max="regional.valorMaximoComissao"
              v-model="form.comissaoAplicada"
            />
            <strong class="flex-shrink-0 text-lg"
              >{{ form.comissaoAplicada }}%</strong
            >
          </div>
        </div>
        <hr class="my-2" />
        <h6 class="mt-5" v-if="configurarComissao">
          Valor Mensal:
          {{ totalSemComissao | currency }}
        </h6>
        <h6
          class="mt-5"
          v-if="configurarComissao && !comissaoRemovidaParcelaUnica"
        >
          {{ $t('Total') }} {{ $t('Comissionamento') }} {{ $t('Recorrente') }}:
          {{ form.valorComissaoAplicadaFinal | currency }}
        </h6>
        <h6 class="mt-5" v-if="comissaoRemovidaParcelaUnica">
          {{ $t('Total') }} {{ $t('Comissionamento') }} {{ $t('Único') }}:
          {{ valorComissionamentoUnico | currency }}
        </h6>
        <h6 class="mt-5">
          {{ $t('Total') }} {{ $t('Mensal') }}:
          {{ totalMensalidade | currency }}
        </h6>
        <h6 class="mt-5">
          {{ $t('Primeira') }} {{ $t('Parcela') }}:
          {{ totalEntrada | currency }}
        </h6>
      </div>
      <div v-else class="vx-col w-full mb-2">
       <vs-alert
         title="Atenção"
         active="true"
         color="danger"
         style="max-height: 220px !important"
       >
         {{ $t('Nenhum') }} {{ $t('produto') }} {{ $t('encontrado') }} {{ $t('para') }} {{ $t('esse') }} {{ $t('veículo') }}, {{ $t('revise') }} {{ $t('os') }} {{ $t('dados') }} {{ $t('do') }} {{ $t('veículo') }}
       </vs-alert>
      </div>
    </div>

    <!-- botão salvar -->
    <div v-if="!finalizada" class="row mt-5 text-right">
      <div class="">
        <vs-button
          color="success"
          v-if="!nenhumProdutoEncontrado"
          class="mr-3 mb-2"
          @click="salvaAlteracoesProduto"
          >Salvar Alterações</vs-button
        >
      </div>
    </div>
    <div>
      <vs-popup
        class="holamundo"
        :title="titleSideBar"
        :active.sync="modalDesconto"
      >
        <formDesconto
          :key="contFormDesconto"
          :dados="item"
          :produtos-selecionados="form.produtosSelecionados"
          :contador="contFormDesconto"
          :modal="modalDesconto"
          :valorMensalidade="totalMensalidade"
          @salvarDesconto="salvaItemValor"
        >
        </formDesconto>
      </vs-popup>
    </div>
    <div>
      <vs-popup
        id="meu-popup-personalizado2"
        class="holamundo"
        :title="'Novo Valor Produto'"
        :active.sync="mostrarModalNovoValorProduto"
      >
        <FormNovoValorProduto
          v-if="mostrarModalNovoValorProduto"
          :produto="novoValorProduto"
          @close="mostrarModalNovoValorProduto = false"
        ></FormNovoValorProduto>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import service from '../../services';
import locale from '../../locale';
import formDesconto from './formDesconto.vue';
import FormNovoValorProduto from './FormNovoValorProduto.vue';
import functions from '../../utils/functions.js';
import jwt from 'jsonwebtoken';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import { obterParticipacaoProduto } from '../../services/cotacao';
import {
  updateProdutoValorMensaliade,
  updateProdutoValorMinimoMensalidade,
} from './../../services/propostas';
import { TIPO_ESTACIONAMENTO } from '../../commons/constant/tipo-estacionameto';


export default {
  props: [
    'dadosProposta',
    'formulario',
    'precisaAlterarProduto',
    'regional',
    'configurarComissao',
    'dadosEmpresa',
  ],
  watch: {
    dadosProposta() {
      this.preencheForm();
    },
    precisaAlterarProduto(newValue) {
      if (newValue) this.formataFormBusca();
    },
    produtos: {
      handler() {
        this.somaValores();
      },
      deep: true,
    },

    'form.estado': function (newValue, oldValue) {
      const isValueChanged = newValue !== oldValue;
      const shouldProcessValueChange =
        isValueChanged && oldValue !== null && typeof oldValue === 'string';

      if (shouldProcessValueChange) {
        this.form.cidade = null;
        this.cidade = null;
        this.cidades = [];
      }
    },
    'form.produtosSelecionados': {
      handler() {
        this.somaValores();
      },
      deep: true,
    },
    'form.comissaoAplicada': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.aumentarComissao = newValue > oldValue;
        this.somaValores();
        this.exibeDescontoDeAcordoComComissao();
      }
    },
    'dadosProposta.comissaoAplicada'(newVal) {
      if (newVal != null) {
        this.form.comissaoAplicada = newVal;
      }
    },
    configurarComissao(configComissao) {
      if (configComissao) {
        this.verificarComissaoRemovidaDesconto();
        this.verificarComissaoRemovidaParcelaUnica();
      }
    },
  },
  computed: {
    finalizada() {
      const { idStatus, nomeStatus } = this.dadosProposta;
      return idStatus === 4 && nomeStatus === 'Finalizada';
    },
    AlterarValorProduto() {
      const bemProtege = functions.verificaEmpresaBemProtege(
        this.formFiltro.idEmpresa,
      );
      if (bemProtege) {
        return this.$can('Alterar Valor Produto', 'Cotações');
      } else {
        return false;
      }
    },
  },
  components: { formDesconto, FormNovoValorProduto },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      produtos: [],
      newProd: null,
      modalValor: false,
      itemValor: null,
      listProdutosObrigatorios: [],
      listProdutosNaoObrigatorios: [],
      mostrarModalNovoValorProduto: false,
      novoValorProduto: {},
      produtosTeste: [],
      modalDesconto: false,
      nenhumProdutoEncontrado: false,
      titleSideBar: 'Desconto',
      item: null,
      contFormDesconto: 0,
      form: {
        idProposta: null,
        produtosAtualizados: null,
        produtosSelecionados: [],
        idTipoDesconto: '',
        jsonFacilitadorProdutos: null,
        comissaoAplicada: 0,
        valorComissaoAplicadaFinal: 0,
      },
      formFiltro: {
        idEmpresa: null,
        idGrupo: null,
        valor: 0,
        cidade: '',
        estado: '',
        restricoesSelecionadas: [],
        veiculo: {
          cilindradas: null,
          resultFipe: {},
        },
      },
      decoded: null,
      totalEntrada: 0,
      totalMensalidade: 0,
      totalSemComissao: 0,
      formComissaoAplicada: 0,
      aumentarComissao: true,
      comissaoRemovidaDesconto: false,
      comissaoRemovidaParcelaUnica: false,
      valorComissionamentoUnico: 0,
    };
  },
  methods: {
    salvaItemValor(item) {
      this.form.idTipoDesconto = item.idTipoDesconto;

      this.listProdutosNaoObrigatorios.forEach((element) => {
        if (element.id_produto == item.id_produto) {
          element.valorFinal = item.valorFinal;
          element.descontoConcedido = item.descontoConcedido;
        }
      });

      this.listProdutosObrigatorios.forEach((element) => {
        if (element.id_produto == item.id_produto) {
          element.valorFinal = item.valorFinal;
          element.descontoConcedido = item.descontoConcedido;
        }
      });

      this.form.produtosSelecionados.forEach((element) => {
        if (element.id_produto == item.id_produto) {
          element.valorFinal = item.valorFinal;
          element.descontoConcedido = item.descontoConcedido;
        }
      });

      if (
        item.descontoConcedido &&
        item.descontoConcedido > 0 &&
        this.form.comissaoAplicada > 0 &&
        !this.dadosEmpresa.exibeDescontoComissionamento
      ) {
        this.form.comissaoAplicada = this.regional.valorMinimoComissao;
        this.comissaoRemovidaDesconto = true;
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Ao aplicar qualquer tipo de desconto, a comissão é ajustada automaticamente para o valor mínimo configurado!',
          color: 'danger',
        });
      }

      if (this.comissaoRemovidaDesconto && !item.descontoConcedido) {
        this.form.comissaoAplicada = this.regional.valorMinimoComissao;
        this.comissaoRemovidaDesconto = false;
        this.comissaoRemovidaParcelaUnica = false;
      }

      this.form.idTipoDesconto = item.idTipoDesconto;
      this.filtraObrigatorios();
      this.filtraNaoObrigatorios();
      this.somaValores();
      this.modalDesconto = false;
    },
    setDesconto(item) {
      var aux = this.produtos.find((x) => x.id_produto == item.id_produto);

      if (item.valorDesconto == 0) {
        aux.valorFinal = item.valor;
        aux.style = null;
      } else {
        aux.style = 'text-decoration: line-through;';
      }
      aux.isDesconto = false;

      this.produtos.forEach((element) => {
        if (element.id == item.id_produto) {
          element.valorFinal = aux.valorFinal;
          element.descontoConcedido = aux.descontoConcedido;
        }
      });
      this.produtoToDesconto = null;
      this.modalDesconto = false;
    },
    /**
     * Opens a modal to display discount information based on the provided item.
     *
     * @param {Object} item - Object containing relevant information for the discount.
     * @param {string} [item.estado] - State associated with the item.
     * @param {string} [item.tipoProposta] - Proposal type associated with the item.
     * @param {number} [item.idEmpresa] - ID of the company associated with the item.
     * @param {string} [item.nomeGrupo] - Name of the group associated with the item.
     * @param {number} [item.valorFipe] - Fipe value associated with the item.
     *
     * @returns {void}
     */
    abrirModalDesconto(item) {
      this.contFormDesconto = this.contFormDesconto + 1;

      if (item) {
        item.estado = this.formulario.dadosCliente.estado;
        item.tipoProposta = this.formulario.dadosGerais.tipoProposta;
        item.idEmpresa = this.formFiltro.idEmpresa;
        item.nomeGrupo = this.dadosProposta.nomeGrupo;
        item.valorFipe = this.dadosProposta.dadosVeiculo.valorFipe;
        this.item = item;
        this.modalDesconto = true;
      }
      // this.itemValor = { ...item };
    },
    filtraNaoObrigatorios() {
      return this.listProdutosNaoObrigatorios.filter((x) => x.show != false);
    },
    filtraObrigatorios() {
      return this.listProdutosObrigatorios.filter((x) => x.show != false);
    },
    calculaValorComissaoUnico() {
      if (this.comissaoRemovidaParcelaUnica) {
        const ID_TIPO_PRODUTO_TX_INSTALACAO_RASTREADOR = 5;
        const idProdutoDuplicado = [];
        this.valorComissionamentoUnico = 0;

        this.form.produtosSelecionados.forEach((produto) => {
          if (
            produto.id_tipoProduto !=
              ID_TIPO_PRODUTO_TX_INSTALACAO_RASTREADOR &&
            !produto.ismensal &&
            !idProdutoDuplicado.includes(produto.id_produto)
          ) {
            idProdutoDuplicado.push(produto.id_produto);
            this.valorComissionamentoUnico += produto.valorFinal;
          }
        });
      }
    },
    removerComissaoParcelaUnica() {
      const produtosDesconto = this.form.produtosSelecionados.some(
        (produto) => produto.descontoConcedido,
      );
      const valorPadraoComissao = produtosDesconto
        ? this.regional.valorMinimoComissao
        : this.regional.valorMaximoComissao;

      this.form.comissaoAplicada = this.comissaoRemovidaParcelaUnica
        ? 0
        : valorPadraoComissao;
      const removeBarraComissao = produtosDesconto
        ? true
        : this.comissaoRemovidaParcelaUnica;
      this.comissaoRemovidaDesconto = removeBarraComissao;

      this.calculaValorComissaoUnico();
    },
    adicionarProduto() {
      if (this.newProd.id_produto) {
        this.form.produtosSelecionados.push({
          id: this.newProd.id_produto,
          valor: this.newProd.valor,
          nomeProduto: this.newProd.nomeProduto,
          obrigatorio: this.newProd.obrigatorio,
          valorFinal: this.newProd.valor,
          isMensal: this.newProd.ismensal,
          descontoConcedido: 0,
          porcentagemDescontoMaxima: this.newProd.porcentagemDescontoMaxima,
        });

        let array = this.listProdutosNaoObrigatorios;
        for (var i = array.length - 1; i >= 0; i--) {
          if (array[i].id_produto == this.newProd.id_produto) {
            array[i].show = false;
          }
        }
      }
      this.newProd = null;
    },
    deletarProduto(id) {
      let array = this.form.produtosSelecionados;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].id == id) {
          array.splice(i, 1);
        }
      }

      let array2 = this.listProdutosNaoObrigatorios;
      for (let i = array2.length - 1; i >= 0; i--) {
        if (array2[i].id_produto == id) {
          array2[i].show = true;
        }
      }
    },

    resetarDescontosCupom(skip = false) {
      const idProposta = this.dadosProposta.idProposta;
      let canReset;
      if (skip == true) {
        canReset = true;
      } else canReset = confirm('Você realmente deseja remover cupom?');
      if (canReset) {
        service
          .post('Cotacao', 'resetar-cupom', { idProposta })
          .then(() => {
            if (skip == false) {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Cupom resetados com sucesso!',
                color: 'success',
              });

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção erro ao resetar cupom!',
              text: error,
              color: 'danger',
            });
          });
      }
    },
    calculaValor(item) {
      const descontoConcedido = parseFloat(item.descontoConcedido);
      const porcentagemDescontoMaxima = parseFloat(
        item.porcentagemDescontoMaxima,
      );
      const itemValor = parseFloat(item.valor);
      let valorFinal = 0;

      const descConcedMaiorQpercDescMax =
        descontoConcedido > porcentagemDescontoMaxima;
      if (descConcedMaiorQpercDescMax) {
        item.descontoConcedido = 0;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Valor de Desconto excede ao valor Permitido',
          color: 'danger',
        });

        return;
      } else {
        valorFinal = itemValor - (itemValor * descontoConcedido) / 100;

        //this.descontoValor = ((this.dados.valor * this.dados.porcentagemDescontoMaxima) / 100)

        const produtosSelecionados = this.form.produtosSelecionados;
        produtosSelecionados.forEach((element) => {
          if (element.id == item.id) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });
        this.form.produtosSelecionados = produtosSelecionados;

        this.listProdutosObrigatorios.forEach((element) => {
          if (element.id == item.id) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });

        this.listProdutosNaoObrigatorios.forEach((element) => {
          if (element.id == item.id) {
            element.valorFinal = valorFinal;
            element.descontoConcedido = descontoConcedido;
          }
        });

        item.descontoConcedido = descontoConcedido;
        item.valorFinal = valorFinal;

        this.filtraObrigatorios();
        this.filtraNaoObrigatorios();
        this.$forceUpdate();
      }
    },
    formataMoeda(valor) {
      if (valor != null) return `R$ ${valor} `;
    },
    somaValorTotalMes() {
      var total = 0;
      this.dadosProposta.produtos.forEach((prod) => {
        if (prod.isMensal == true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotal() {
      var total = 0;
      this.dadosProposta.produtos.forEach((prod) => {
        if (prod.isMensal != true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotalMesAtualizados() {
      var total = 0;
      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal == true) {
          total = total + prod.valorFinal;
        }
      });
      return total;
    },
    somaValorTotalAtualizados() {
      var total = 0;
      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal != true) total = total + prod.valorFinal;
      });
      return total;
    },
    produtosObrigatorios() {
      return this.dadosProposta.produtos.filter((x) => x.obrigatorio == true);
    },
    produtosNaoObrigatorios() {
      return this.dadosProposta.produtos.filter((x) => x.obrigatorio != true);
    },
    atualizarProdutosValorAlterado() {
      const produtosValorAlterado = this.dadosProposta.produtos.filter(
        (produto) =>
          produto.valorOriginal && produto.valor !== produto.valorOriginal,
      );

      if (produtosValorAlterado.length) {
        this.atribuiValorAlteradoAProduto(produtosValorAlterado);
      }
    },
    atribuiValorAlteradoAProduto(produtosValorAlterado) {
      produtosValorAlterado.forEach((pr) => {
        const prodObrig = this.listProdutosObrigatorios.find(
          (p) => +pr.idProduto === +p.id_produto,
        );
        const prodOpc = this.listProdutosNaoObrigatorios.find(
          (p) => +pr.idProduto === +p.id_produto,
        );
        const produto = prodObrig || prodOpc;

        produto.valor = pr.valor;
        produto.valorOriginal = pr.valorOriginal;
        produto.valorFinal = pr.valorFinal;
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      const { idProposta: propsIdProposta } = this.formulario.dadosProduto;
      const { idProposta, produtos, jsonFacilitador } = this.dadosProposta;

      if (propsIdProposta) {
        this.form = this.formulario.dadosProduto;
      }

      if (!propsIdProposta && idProposta) {
        this.form.idProposta = idProposta;
        this.form.produtosSelecionados = produtos;
      }

      this.form.jsonFacilitadorProdutos = jsonFacilitador;

      this.formataFormBusca();
      this.emitLoadedForm();
    },
    formataFormBusca() {
      const _formFiltro = {
        idEmpresa: null,
        idGrupo: null,
        valor: 0,
        cidade: '',
        estado: '',
        valorTotalConjunto,
        valorCobertura,
        somenteAgregado: null,
        restricoesSelecionadas: [],
        idTipoFipe: {},
        veiculo: {
          cilindradas: null,
          resultFipe: {},
        },
        regional: {
          id: null,
        },
      };

      let resultFipeProp;
      let resultFipeForm;

      const {
        idEmpresa,
        idGrupo,
        valorNf,
        tipoProposta,
        valorTotalConjunto,
        idRegional,
      } = this.dadosProposta;

      const { cidade, estado } = this.dadosProposta.dadosCliente;

      const {
        resultadoFipe = {},
        cilindradas = '',
        valorCobertura,
        valorFipe,
      } = this.dadosProposta.dadosVeiculo;

      const {
        restricoesSelecionadas,
        tipoProposta: tipoPropostaFormulario,
        valorNf: valorNfFormulario,
      } = this.formulario.dadosGerais;

      const {
        veiculo: veiculoFormulario,
        cilindradas: cilindradasFormulario = '',
      } = this.formulario.dadosVeiculo;

      const { cidade: cidadeFormulario = '', estado: estadoFormulario = '' } =
        this.formulario.dadosCliente;

      const {
        dadosVeiculo: {
          valorCobertura: valorCoberturaForm,
          valorFipe: valorFipeForm,
          valorTotalConjunto: valorTotalConjuntoForm,
        },
      } = this.formulario;

      _formFiltro['idEmpresa'] = idEmpresa ? idEmpresa : null;

      _formFiltro['idUsuarioConsultor'] = this.dadosProposta.dadosVendedor
        .idUsuario
        ? this.dadosProposta.dadosVendedor.idUsuario
        : null;

      _formFiltro['valorTotalConjunto'] = valorTotalConjuntoForm
        ? valorTotalConjuntoForm
        : valorTotalConjunto || valorFipeForm || valorFipe || valorNf;

      _formFiltro['valorCobertura'] = valorCoberturaForm
        ? valorCoberturaForm
        : valorCobertura || valorFipeForm || valorFipe || valorNf;

      const isArrRestricoesSelecionadas = Array.isArray(restricoesSelecionadas);
      _formFiltro['restricoesSelecionadas'] = isArrRestricoesSelecionadas
        ? restricoesSelecionadas
        : [];

      const objVeiculoVazio = this._isObjectEmpty(veiculoFormulario);

      if (objVeiculoVazio) {
        _formFiltro['idGrupo'] = idGrupo;
        resultFipeProp = JSON.parse(resultadoFipe);

        if (resultFipeProp) _formFiltro['valor'] = resultFipeProp.preco;

        _formFiltro['cidade'] = cidade ? cidade : '';
        _formFiltro['estado'] = estado ? estado : '';
        _formFiltro.veiculo.cilindradas =
          cilindradas !== null ? cilindradas : '';
        _formFiltro.veiculo.resultFipe = resultFipeProp;
      }

      if (!objVeiculoVazio) {
        resultFipeForm =
          typeof veiculoFormulario.resultFipe === 'string'
            ? JSON.parse(veiculoFormulario.resultFipe)
            : veiculoFormulario.resultFipe;

        _formFiltro['idGrupo'] =
          veiculoFormulario.idGrupo === null
            ? idGrupo
            : veiculoFormulario.idGrupo;

        if (resultFipeForm) {
          _formFiltro['valor'] =
            resultFipeForm.preco === null
              ? resultFipeProp.preco
              : resultFipeForm.preco;

          _formFiltro.veiculo.resultFipe =
            resultFipeForm.preco === null ? resultFipeProp : resultFipeForm;
        }

        _formFiltro['cidade'] =
          cidadeFormulario === null ? cidade : cidadeFormulario;

        _formFiltro['estado'] =
          estadoFormulario === null ? estado : estadoFormulario;

        _formFiltro.veiculo.cilindradas =
          cilindradasFormulario === null ? cilindradas : cilindradasFormulario;

        const resultFipeString = typeof _formFiltro.veiculo.resultFipe;

        _formFiltro.veiculo.resultFipe =
          resultFipeString == 'string'
            ? JSON.parse(_formFiltro.veiculo.resultFipe)
            : _formFiltro.veiculo.resultFipe;
      }

      // substituir o valor da FIPE pelo valor da nota informado na criação da proposta
      if (valorNf > 0)
        _formFiltro.veiculo.resultFipe.preco = this.retornaMoeda(valorNf);

      const formataNfFormulario =
        typeof valorNfFormulario === 'string'
          ? valorNfFormulario.replace('.', '').replace(',', '.')
          : void 0;

      const convertNfFormularioNum = parseFloat(formataNfFormulario);
      const valorNfEditado =
        convertNfFormularioNum > 0 && valorNf !== convertNfFormularioNum;

      //substitui o valor da FIPE pelo valor da nota editado
      if (valorNfEditado)
        _formFiltro.veiculo.resultFipe.preco = convertNfFormularioNum;

      _formFiltro['idGrupo'] = { id: _formFiltro.idGrupo };

      _formFiltro.veiculo.marca = {
        id: _formFiltro.veiculo.resultFipe.id_marca,
      };

      _formFiltro.veiculo.modelo = {
        id: _formFiltro.veiculo.resultFipe.id_modelo,
      };

      _formFiltro['tipoProposta'] =
        tipoPropostaFormulario === null ? tipoProposta : tipoPropostaFormulario;

      _formFiltro.veiculo.codTipoVeiculo =
        this.dadosProposta.dadosVeiculo.codTipoVeiculo;

      _formFiltro.idTipoFipe.id =
        this.dadosProposta.dadosVeiculo.codTipoVeiculo;

      _formFiltro.somenteAgregado = this.dadosProposta.somenteAgregado;

      _formFiltro.regional.id = idRegional;

      this.formFiltro = _formFiltro;

      this.buscaProdutos();
    },
    buscaProdutos() {
      return new Promise(async (resolve, reject) => {
        this.$vs.loading();
        this.contadorBuscaProdutos = 0;

        service
          .post('Cotacao', 'BuscaProdutos', this.formFiltro)
          .then((res) => {
            if (res.data.length == 0) {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Nenhum Produto Encontrado para esse veículo',
                color: 'danger',
              });
              this.nenhumProdutoEncontrado = true;
              this.$emit('naoSalvarProdutos', this.nenhumProdutoEncontrado);
              reject('Nenhum Produto Encontrado para esse veículo');
            } else {
              this.nenhumProdutoEncontrado = false;
              this.$emit('naoSalvarProdutos', this.nenhumProdutoEncontrado);

              this.produtos = res.data.produtosVeiculo
                ? res.data.produtosVeiculo
                : res.data;

              this.listProdutosObrigatorios = [];
              this.listProdutosNaoObrigatorios = [];
              this.form.produtosSelecionados = [];

              /*
              conforme alinhado em reuniao dia 08/11/23 (fabio e stevan) sempre que sofrer alteracao da proposta
              que afete buscar os produtos novamente os descontos devem ser zerados automaticamente
              senao passa pelo processo normal
              */
              if (this.precisaAlterarProduto == true) {
                //reseta descontos pulando passo de confirmacao
                this.resetarDescontosCupom(true);
              }

              this.produtos.forEach((element) => {
                element.valorFinal = element.valor;
                element.descontoConcedido = 0;
                element.id = element.id_produto;

                /*
                conforme definição acima mencionada se nao precisar alterar os produtos os valores de desconto
                devem continuar preenchidos
                */
                if (this.precisaAlterarProduto == false) {
                  //reseta descontos pulando passo de confirmacao

                  // Carrega os valores de desconto e valores editados
                  var aux = this.dadosProposta.produtos.find(
                    (x) => x.idProduto == element.id_produto,
                  );

                  // calcula o desconto sobre valor original
                  if (aux) {
                    const diferencaValor = aux.valor - aux.valorFinal;

                    if (aux.descontoConcedido) {
                      element.descontoConcedido = this.calculaPercentulDesconto(
                        diferencaValor,
                        aux.valor,
                      );
                    }

                    if (aux.valorDescontoCupom) {
                      element.valorDescontoCupomExibicao =
                        this.calculaPercentulDesconto(
                          aux.valorDescontoCupom,
                          aux.valor,
                        );
                    }

                    const diferencaDeValorNaoEhZeroEEstacionamentoNaoEhNaRua =
                      diferencaValor !== 0 &&
                      this.formulario.dadosVeiculo.veiculo
                        .idTipoEstacionamento !==
                        TIPO_ESTACIONAMENTO.ESTACIONAMENTO_NA_RUA;

                    element.valor =
                      diferencaDeValorNaoEhZeroEEstacionamentoNaoEhNaRua
                        ? element.valor
                        : aux.valor;

                    element.valorFinal =
                      diferencaValor !== 0
                        ? element.valor - diferencaValor
                        : aux.valorFinal;

                    element.valorDescontoCupom = aux.valorDescontoCupom;
                  }
                }

                // separa produtos obrigatorios e produtos selecionados
                if (element.obrigatorio == true) {
                  this.listProdutosObrigatorios.push(element);

                  const produtoSelecionado = this.validaSelecionado(element);

                  if (!produtoSelecionado) {
                    this.form.produtosSelecionados.push(element);
                  }
                } else {
                  element.selecionado = true;
                  this.listProdutosNaoObrigatorios.push(element);
                  // this.form.produtosSelecionados.push(element);
                }

                //Adiciona a propriedade exibir nos produtos para utilização da lógica de mostrar/não-mostrar complementares
                if (element.isComplementar) {
                  element.exibir = false;
                } else {
                  element.exibir = true;
                }
              });

              const produtosNaoObrigSelecionados =
                this.produtosNaoObrigatorios();

              // verifica se o item não obrigatorio está selecionado
              produtosNaoObrigSelecionados.forEach((itemNObri) => {
                const _prod = this.produtos.find(
                  (itemProd) => itemNObri.idProduto == itemProd.id_produto,
                );

                const produtoSelecionado = this.validaSelecionado(_prod);

                if (_prod && !produtoSelecionado) {
                  this.form.produtosSelecionados.push(_prod);
                }
              });

              // sobrepõe produtos
              this.form.produtosSelecionados.forEach((item) => {
                if (item.sobreporOutrosProdutos) {
                  const prodssobreporOutrosProdutos =
                    item.sobreporOutrosProdutos.split(',');

                  const produtoSelecionado = this.validaSelecionado(item);

                  prodssobreporOutrosProdutos.forEach((element) => {
                    this.form.produtosSelecionados.forEach(
                      (elementSel, index) => {
                        if (elementSel.id == element && !produtoSelecionado) {
                          this.form.produtosSelecionados.splice(index, 1);
                        }
                      },
                    );
                  });
                }
              });

              this.$emit('ProdutosAtualizados', true);

              this.form.jsonFacilitadorProdutos = JSON.stringify(this.produtos);

              this.emitChangedForm(
                'jsonFacilitadorProdutos',
                this.form.jsonFacilitadorProdutos,
              );

              localStorage.setItem(
                'formFiltro',
                JSON.stringify(this.formFiltro),
              );
            }

            this.atualizarProdutosValorAlterado();

            this.exibeDescontoDeAcordoComComissao();

            this.$vs.loading.close();
          })
          .catch((e) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            reject(e);
          });
      });
    },
    retornaMoeda(valor) {
      return 'R$ ' + valor;
    },
    buscaProdutosSobrepoeFaltante() {
      var arrFaltante = [];
      this.listProdutosObrigatorios.forEach((element) => {
        var aux = this.form.produtosSelecionados.find(
          (x) => x.id == element.id_produto,
        );
        if (!aux) arrFaltante.push(element);
      });
      if (arrFaltante.length > 0) {
        var arrEncontrou = [];
        arrFaltante.forEach((elementFaltante) => {
          this.form.produtosSelecionados.forEach((element) => {
            var aux = this.produtos.find((x) => x.id_produto == element.id);
            if (aux.sobreporOutrosProdutos) {
              var prodssobreporOutrosProdutos =
                aux.sobreporOutrosProdutos.split(',');
              var aux2 = prodssobreporOutrosProdutos.filter(
                (x) => x == elementFaltante.id_produto,
              );
              if (aux2.length > 0) {
                arrEncontrou.push(aux2[0]);
              }
            }
          });

          if (arrEncontrou.length == 0) {
            this.form.produtosSelecionados.push(elementFaltante);
          }
        });
      }
    },
    validaSelecionado(item) {
      if (!item) return;

      var aux = this.form.produtosSelecionados.filter(
        (x) => x.id == item.id_produto,
      );
      if (item.obrigatorio && aux.length > 0) return true;
      else if (item.obrigatorio && aux.length == 0) return false;
      return false;
    },
    async selecionaProduto(item) {
      // sobrepoe produtos
      if (item.sobreporOutrosProdutos) {
        var prodssobreporOutrosProdutos =
          item.sobreporOutrosProdutos.split(',');

        prodssobreporOutrosProdutos.forEach((element) => {
          this.form.produtosSelecionados.forEach((elementSel, index) => {
            if (elementSel.id == element) {
              this.form.produtosSelecionados.splice(index, 1);
            }
          });
        });
      } else {
        this.produtos.forEach((element) => {
          if (element.sobreporOutrosProdutos) {
            var prodssobreporOutrosProdutos =
              element.sobreporOutrosProdutos.split(',');
            var aux = prodssobreporOutrosProdutos.find(
              (x) => x == item.id_produto,
            );
            if (aux) {
              this.form.produtosSelecionados.forEach((selecionado, index) => {
                if (selecionado.id == element.id_produto) {
                  this.form.produtosSelecionados.splice(index, 1);
                }
              });
            }
          }
        });
      }
      this.buscaProdutosSobrepoeFaltante();

      // produtos linkados
      if (item.produtosLinkados) {
        const produtosLinkados = item.produtosLinkados.split(',');
        produtosLinkados.forEach((id) => {
          const produtoLinkado = this.produtos.find(
            (produto) => produto.id_produto == id,
          );

          if (!produtoLinkado) return;

          const existeSelecionado = this.form.produtosSelecionados.find(
            (item) => item.id_produto === produtoLinkado.id_produto,
          );

          const produtoNaoPai = this.form.produtosSelecionados.find(
            (produto) => produto.id_produto === item.id_produto,
          );

          const selecionaProdutoLinkado = !existeSelecionado && produtoNaoPai;
          if (selecionaProdutoLinkado) {
            this.form.produtosSelecionados.push(produtoLinkado);
          }

          const removeProdutoLinkado = existeSelecionado && !produtoNaoPai;
          if (removeProdutoLinkado) {
            this.form.produtosSelecionados.forEach((elementSel, index) => {
              if (elementSel.id_produto === produtoLinkado.id_produto)
                this.form.produtosSelecionados.splice(index, 1);
            });
          }
        });
      }

      //Produtos complementares
      if (item.produtosComplementares) {
        const produtosComplementares = item.produtosComplementares.split(',');

        produtosComplementares.forEach((id) => {
          this.produtos.forEach((prod) => {
            if (prod.id_produto == id) {
              prod.exibir = !prod.exibir;
            }
          });

          this.form.produtosSelecionados.forEach((prod, index) => {
            if (prod.id_produto == id && prod.exibir == false) {
              this.form.produtosSelecionados.splice(index, 1);
            }
          });
        });
      }

      this.form.produtosSelecionados.forEach((produto) => {
        const produtoEncontrado = this.dadosProposta.produtos.find(
          (findProd) => produto.id_produto === findProd.idProduto,
        );

        if (produtoEncontrado) {
          Object.assign(produto, {
            idTipoPagamentoEmpresa: produtoEncontrado.idTipoPagamentoEmpresa,
            nomePagamento: produtoEncontrado.nomePagamento,
            valorDescontoCupom: produtoEncontrado.valorDescontoCupom,
          });
        }
      });

      // Atualiza cota de participação
      if (item.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO) {
        const participacao = await obterParticipacaoProduto(
          item,
          this.form.produtosSelecionados,
        );

        this.emitChangedForm(
          'particiapacao',
          participacao,
          'dadosProduto',
          'atualizarParticipacao',
        );
      }
    },
    emitLoadedForm() {
      this.form.produtos = this.produtos;
      this.$emit('loaded', { formulario: 'dadosProduto', ...this.form });
    },
    emitChangedForm(id, value, formulario = 'dadosProduto', acao = 'changed') {
      this.$emit(acao, { formulario, id, value });
    },
    salvaAlteracoesProduto() {
      this.emitLoadedForm();
      this.$emit('salvar');
    },
    _isObjectEmpty(value) {
      const isEmpty =
        value && Object.keys(value).length && value.constructor === Object;

      return !isEmpty;
    },
    calculaPercentulDesconto(diferenca, valorOrginal) {
      return (diferenca / valorOrginal) * 100;
    },
    verificaToken() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
    },
    verificaPermissaoDescontoPorPerfil(ids) {
      if (ids) {
        const arrayIds = ids.split(', ').map((id) => id.trim());
        return arrayIds.includes(this.decoded.id_perfil.toString());
      } else return this.$can('Pode oferecer desconto', 'Cotações');
    },
    somaValores() {
      this.totalMensalidade = this.somaValorTotalMesAtualizados();
      this.totalSemComissao = this.somaValorTotalMesAtualizados();
      updateProdutoValorMensaliade(this.produtos, this.totalMensalidade);

      const valorComissaoAplicada = this.calcularEAumentarComissao();

      this.totalEntrada = this.somaValorTotalAtualizados();

      updateProdutoValorMinimoMensalidade(
        this.produtos,
        this.totalMensalidade,
        valorComissaoAplicada,
        this.aumentarComissao,
      );

      this.calculaValorComissaoUnico();
    },
    calcularEAumentarComissao() {
      const aumentoComissao =
        this.form.comissaoAplicada > 0
          ? this.totalMensalidade * (this.form.comissaoAplicada / 100)
          : 0;

      this.form.valorComissaoAplicadaFinal = aumentoComissao;

      this.emitChangedForm(
        'valorComissaoAplicadaFinal',
        this.form.valorComissaoAplicadaFinal,
      );

      this.emitChangedForm('comissaoAplicada', this.form.comissaoAplicada);

      this.totalMensalidade += aumentoComissao;

      return aumentoComissao;
    },
    verificarComissaoRemovidaDesconto() {
      if (
        this.configurarComissao &&
        !this.dadosEmpresa.exibeDescontoComissionamento
      ) {
        this.form.produtosSelecionados.forEach((produto) => {
          if (produto.descontoConcedido) {
            this.comissaoRemovidaDesconto = true;
          }
        });
      }
    },
    verificarComissaoRemovidaParcelaUnica() {
      if (this.configurarComissao && this.form.comissaoAplicada === 0) {
        this.comissaoRemovidaParcelaUnica = true;
        this.removerComissaoParcelaUnica();
      }
    },
    exibeBotaoDesconto(produto) {
      if (produto.exibeDescontoComissionamento) {
        if (
          this.form.comissaoAplicada >=
          this.dadosEmpresa.percentualComissionamento
        ) {
          produto.descontoConcedido = 0;
          produto.valorFinal = produto.valor;

          this.somaValores();
          return false;
        }
      }

      return true;
    },
    exibeDescontoDeAcordoComComissao() {
      const arraysDeProdutos = [this.produtos, this.form.produtosSelecionados];

      arraysDeProdutos.forEach((produtos) => {
        produtos.forEach((produto) => {
          produto.podeExibirBotaoDesconto = this.exibeBotaoDesconto(produto);
        });
      });
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.verificaToken();
  },
};
</script>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.inner-popup {
  z-index: 999999 !important;
}

.slider {
  background: #158c12;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: #158c12;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}

.slider::-moz-range-thumb {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: #158c12;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}
</style>

<style>
#meu-popup-personalizado2.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
